import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader'
import FinancePartnerModal from './FinancePartnerModal'
import FinancePartnerGrid from './FinancePartnerGrid'
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts'
import axios from 'axios'
import { getStorageValues } from '../../shared/CommonFunctions'
import { getApiBaseUrl } from '../../utils/apiConfig'
import { getModulePermissions } from '../../utils/permissionHelper'
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles'
import { logAuditEvent } from '../../utils/auditLogger'

function FinancePartnerMain(props) {
  const [financePartnerList, setFinancePartnerList] = useState([])
  const [modalIsOpen, setIsOpen] = React.useState(false)
  const [alert, setAlert] = useState(null)
  const [userModulePermission, setUserModulePermission] = React.useState([])
  const moduleName = props.Module || 'Finance Partners'

  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module)
    setUserModulePermission(modulePermissions ? modulePermissions : [])
    fetchFinancePartners()
  }, [props.Module])

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', `Accessed ${moduleName}`)
  }, [moduleName])

  function openAddModal() {
    setIsOpen(true)
    logAuditEvent(moduleName, 'Add Button Click', `Opened add ${moduleName} modal`)
  }

  function closeModal() {
    setIsOpen(false)
  }

  async function onSubmit(e, data) {
    if (e.target.name === 'Add') {
      const financePartnerModel = data
      if (financePartnerModel) {
        let financePartnerDetails = {
          FinancePartnerId: null,
          FinancePartnerName: financePartnerModel.FinancePartnerName ? financePartnerModel.FinancePartnerName : '',
          InterestRate: financePartnerModel.InterestRate ?? null,
          MinimumDownPayment: financePartnerModel.MinimumDownPayment ?? null,
          ContactPerson1: financePartnerModel.ContactPerson1 ?? '',
          ContactPhone1: financePartnerModel.ContactPhone1 ?? '',
          ContactPerson2: financePartnerModel.ContactPerson2 ?? '',
          ContactPhone2: financePartnerModel.ContactPhone2 ?? '',
          EmailId: financePartnerModel.EmailId ?? '',
          Sequance: financePartnerModel.Sequance ?? null,
          UserId: getStorageValues('userId')
        }
        if (validation(financePartnerDetails)) {
          try {
            const response = await axios.post(
              getApiBaseUrl() + '/financepartner/save',
              financePartnerDetails
            )
            if (response.status === 200) {
              if (response.data.data[0]?.success === 1) {
                CreateAlert(response.data.data[0]?.message, 'Success', setAlert)
                fetchFinancePartners()
                closeModal()
              } else {
                CreateAlert(response.data.data[0]?.message || 'Unable to save record', 'Error', setAlert)
              }
            }
          } catch (error) {
            console.log(error)
          }
        }
      } else {
        CreateAlert('Fields marked with an asterisk (*) are required!!', 'Error', setAlert)
      }
    }
  }

  function validation(financePartnerDetails) {
    let isValid = true
    if (financePartnerDetails) {
      if (financePartnerDetails.FinancePartnerName !== null && financePartnerDetails.FinancePartnerName !== undefined) {
        if (financePartnerDetails.FinancePartnerName.length === 0) {
          CreateAlert('Please enter finance partner name!!', 'Warning', setAlert)
          isValid = false
          return
        }
      } else {
        CreateAlert('Please enter finance partner name!!', 'Warning', setAlert)
        isValid = false
        return
      }
    } else {
      CreateAlert('Some problem fetching user details entered by the user!!', 'Error', setAlert)
      isValid = false
      return
    }
    return isValid
  }

  const fetchFinancePartners = async () => {
    try {
      const response = await axios.get(getApiBaseUrl() + '/financepartner/getAll', {
        params: { UserId: getStorageValues('userId') }
      })
      if (response.status === 200) {
        setFinancePartnerList(response.data.data[0] || [])
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleExportExcel = () => {
    const columns = [
      { name: 'Finance Partner', selector: 'FinancePartnerName' },
      { name: 'Interest Rate', selector: 'InterestRate' },
      { name: 'Minimum Down Payment', selector: 'MinimumDownPayment' },
      { name: 'Contact Person 1', selector: 'ContactPerson1' },
      { name: 'Contact Phone 1', selector: 'ContactPhone1' },
      { name: 'Contact Person 2', selector: 'ContactPerson2' },
      { name: 'Contact Phone 2', selector: 'ContactPhone2' },
      { name: 'Email', selector: 'EmailId' },
      { name: 'Sequance', selector: 'Sequance' }
    ]
    exportToExcel('FinancePartners', columns, financePartnerList)
  }

  const handleExportPDF = () => {
    const columns = [
      { name: 'Finance Partner', selector: 'FinancePartnerName' },
      { name: 'Interest Rate', selector: 'InterestRate' },
      { name: 'Minimum Down Payment', selector: 'MinimumDownPayment' },
      { name: 'Contact Person 1', selector: 'ContactPerson1' },
      { name: 'Contact Phone 1', selector: 'ContactPhone1' },
      { name: 'Contact Person 2', selector: 'ContactPerson2' },
      { name: 'Contact Phone 2', selector: 'ContactPhone2' },
      { name: 'Email', selector: 'EmailId' },
      { name: 'Sequance', selector: 'Sequance' }
    ]
    exportToPDF('FinancePartners', columns, financePartnerList)
  }

  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal}
        onRefresh={fetchFinancePartners}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={userModulePermission.AddModule === 1 ? true : false}
      />
      <FinancePartnerGrid
        FinancePartnerData={financePartnerList}
        fetchFinancePartners={fetchFinancePartners}
        UserPermissions={userModulePermission}
        moduleName={moduleName}
      />
      <FinancePartnerModal
        show={modalIsOpen}
        UserAction={'Add'}
        onClose={closeModal}
        onSubmit={onSubmit}
        moduleName={moduleName}
      />
    </>
  )
}

export default FinancePartnerMain
